import angular from 'angular'
import dcMiniCalendarAgendaController from './mini-calendar-agenda.directive'
import dcMiniCalendar from './mini-calendar-agenda.directive'

export default angular.module( 'directives.calendaragenda', [] )
    .controller( 'dcMiniCalendarAgendaController', dcMiniCalendarAgendaController )
    .directive( 'dcMiniCalendarAgenda', dcMiniCalendar );

